import React from 'react';
import PropTypes from 'prop-types';
import './LinkModal.css';

/**
 * Modal that displays an external URL in an iframe.
 * Includes a button to open the URL in a new browser tab.
 */
const LinkModal = ({ url, title, isOpen, onClose }) => {
  if (!isOpen || !url) return null;

  const handleOpenNewTab = () => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="link-modal-overlay">
      <button
        type="button"
        className="link-modal-backdrop"
        onClick={onClose}
        aria-label="Schließen"
      />
      <dialog className="link-modal-dialog" open aria-label={title || 'Externer Link'}>
        <div className="link-modal-header">
          <div className="link-modal-title">
            <i className="bi bi-link-45deg"></i>
            <span>{title || url}</span>
          </div>
          <div className="link-modal-header-actions">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary link-modal-newtab-btn"
              onClick={handleOpenNewTab}
              title="In neuem Tab öffnen"
            >
              <i className="bi bi-box-arrow-up-right"></i> Neuer Tab
            </button>
            <button
              type="button"
              className="link-modal-close-btn"
              onClick={onClose}
              aria-label="Schließen"
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
        <div className="link-modal-body">
          <iframe
            src={url}
            title={title || 'Externer Link'}
            className="link-modal-iframe"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          />
        </div>
      </dialog>
    </div>
  );
};

LinkModal.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LinkModal;
